import React from 'react';
import {DatePicker} from 'antd';
import {DATE_FORMAT} from '../../constants';

const OogstDatePicker = (props) => {
    const {
        format = DATE_FORMAT,
        style = {width: '100%'},
        ...rest
    } = props;

    return (
        <DatePicker
            showWeek
            format={format}
            style={style}
            {...rest}
        />
    );
};

export default OogstDatePicker;